// Textos compartidos en todo el sitio: navegación, portada, pie de página, WhatsApp y mensajes del sistema.
const common = {
  nav: {
    '/': 'Inicio',
    '/products': 'Productos',
    '/uses': 'Guía de grados',
    '/how-we-work': 'Cómo trabajamos',
    '/true-cinnamon': 'Canela verdadera',
    '/contact': 'Contacto',
  },
  homeLinkLabel: 'Spice Yield, inicio',
  menuToggle: 'Abrir o cerrar el menú',
  themeToLight: 'Cambiar a modo claro',
  themeToDark: 'Cambiar a modo oscuro',
  languageSwitch: 'Idioma',

  whatsapp: {
    label: 'Escríbanos por WhatsApp',
    defaultMessage: '¡Hola! Me interesan sus productos de canela de Ceilán. ¿Me pueden ayudar?',
    quoteMessage: '¡Hola! Quisiera una cotización de canela de Ceilán.\nGrado / uso:\nCantidad:\nDestino:',
  },

  hero: {
    heading: 'Exportador de canela de Ceilán desde Sri Lanka',
    slides: [
      {
        badge: 'Grados de exportación',
        title: 'Todos los grados, de C5 a H3',
        subtitle: 'Canela en rama, quillings, recortes y aceite de canela, empacados según sus especificaciones.',
      },
      {
        badge: 'Cinnamomum verum',
        title: 'Canela de Ceilán',
        subtitle: 'Canela verdadera del sur de Sri Lanka, pelada y enrollada a mano.',
      },
      {
        badge: 'Desde el origen',
        title: 'Cultivada en Sri Lanka',
        subtitle: 'Plántulas de canela en nuestro vivero, antes de trasplantarlas a la plantación.',
      },
    ],
    viewProducts: 'Ver productos',
    requestQuote: 'Solicitar cotización',
    slideLabel: (n, title) => `Mostrar diapositiva ${n}: ${title}`,
  },

  certifications: {
    label: 'Certificaciones',
    exporter: 'Exportador registrado ante el EDB',
    items: [
      { name: 'Pure Ceylon Cinnamon', desc: 'Licencia del logo del león (EDB)' },
      { name: 'Ceylon Cinnamon PGI', desc: 'Indicación geográfica de la UE' },
      { name: 'Halal', desc: 'Certificación halal' },
      { name: 'SLS 81', desc: 'Clasificada según la norma de Sri Lanka' },
      { name: 'GMP', desc: 'Planta de proceso certificada' },
      { name: 'ISO 22000', desc: 'Gestión de inocuidad alimentaria' },
      { name: 'BRCGS', desc: 'Norma global de inocuidad' },
    ],
  },

  footer: {
    description: 'Canela de Ceilán cultivada, pelada y clasificada en el sur de Sri Lanka, y exportada a compradores de todo el mundo.',
    ctaTitle: '¿Listo para cotizar?',
    ctaText: 'Indíquenos el grado, la cantidad y el destino. Respondemos en un día hábil.',
    ctaButton: 'Solicitar cotización',
    ctaWhatsapp: 'Escríbanos por WhatsApp',
    products: 'Productos',
    company: 'Empresa',
    contact: 'Contacto',
    productLinks: {
      continental: 'Rama Continental',
      hamburg: 'Rama Hamburgo',
      pieces: 'Quillings y recortes',
      'other-products': 'Aceite, pimienta y areca',
    },
    sriLanka: 'Sri Lanka',
    singapore: 'Singapur',
    rights: 'Todos los derechos reservados.',
  },

  languageSuggestion: {
    text: '¿Prefiere leer en español?',
    action: 'Ver el sitio en español',
    dismiss: 'Cerrar',
  },

  notFound: {
    title: 'Página no encontrada',
    text: 'La página que busca no existe o cambió de dirección.',
    products: 'Ver productos',
    home: 'Ir al inicio',
  },

  error: {
    title: 'Algo salió mal',
    text: 'Esta página tuvo un problema, a veces causado por un traductor del navegador. Recargar la página suele resolverlo.',
    reload: 'Recargar la página',
  },
};

export default common;
